import { UnavailableWindow} from '@m4a3/api-client';
import {
  GET_UNAVAILABLE_WINDOWS
} from 'actions/actionTypes';
import { AnyAction } from 'redux';

interface UnavailableWindowReducerState {
  unavailablewindows: UnavailableWindow[],
}
const defaultState: UnavailableWindowReducerState = {
  unavailablewindows: [],
};

export default (state: UnavailableWindowReducerState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case GET_UNAVAILABLE_WINDOWS:{
      return {
        ...state,
        unavailablewindows: action.payload,
      }
    }
    default:
      return state;
    }
};
